import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '12月有奖提问提现入口';

const route: RouteConfig = {
  path: '/2019QuestionMaster',
  name: 'QuestionMaster',
  component: () => import('./Home.vue'),
  redirect: '/2019QuestionMaster/First',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'first',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'second',
      component: () => import('./Second.vue'),
      name: 'second',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'third',
      component: () => import('./Third.vue'),
      name: 'third',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'fourth',
      component: () => import('./Fourth.vue'),
      name: 'fourth',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
